"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shop_api = void 0;

var _lsfastapiClient = require("@lsoft/lsfastapi-client");

var openapi = {
  openapi: "3.0.2",
  info: {
    title: "shop-api",
    version: "4.0.0"
  },
  paths: {
    "/shop/session/app/{app_name}": {
      get: {
        tags: ["session"],
        summary: "Shop Session App Get",
        operationId: "shop_session_app__app_name__get",
        parameters: [{
          required: true,
          schema: {
            title: "App Name",
            type: "string"
          },
          name: "app_name",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ShopSessionModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/shop/session/app/{app_name}/login": {
      post: {
        tags: ["session"],
        summary: "Shop Session App Login Post",
        operationId: "shop_session_app__app_name__login_post",
        parameters: [{
          required: true,
          schema: {
            title: "App Name",
            type: "string"
          },
          name: "app_name",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/LoginCredentialsModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/LoginResultModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/shop/session/app/{app_name}/logout": {
      get: {
        tags: ["session"],
        summary: "Shop Session App Logout Get",
        operationId: "shop_session_app__app_name__logout_get",
        parameters: [{
          required: true,
          schema: {
            title: "App Name",
            type: "string"
          },
          name: "app_name",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ShopSessionModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/shop/session/{session_id}": {
      put: {
        tags: ["session"],
        summary: "Shop Session Put",
        operationId: "shop_session__session_id__put",
        parameters: [{
          required: true,
          schema: {
            title: "Session Id",
            type: "string"
          },
          name: "session_id",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/ShopSessionModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ShopSessionModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/shop/session/{session_id}/archive": {
      get: {
        tags: ["session"],
        summary: "Shop Session Archive Get",
        operationId: "shop_session__session_id__archive_get",
        parameters: [{
          required: true,
          schema: {
            title: "Session Id",
            type: "string"
          },
          name: "session_id",
          "in": "path"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/ShopSessionModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/register/app/{app_name}": {
      post: {
        tags: ["customer"],
        summary: "Customer Register Post",
        operationId: "customer_register_app__app_name__post",
        parameters: [{
          required: true,
          schema: {
            title: "App Name",
            type: "string"
          },
          name: "app_name",
          "in": "path"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/CustomerRegisterModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/LoginResultModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/contact/exists": {
      get: {
        tags: ["customer"],
        summary: "Customer Contact Exists Get",
        operationId: "customer_contact_exists_get",
        parameters: [{
          required: true,
          schema: {
            title: "Email",
            type: "string"
          },
          name: "email",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/CustomerContactExistsModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/contact/password_reset": {
      put: {
        tags: ["customer"],
        summary: "Customer Contact Password Reset Put",
        operationId: "customer_contact_password_reset_put",
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/CustomerPasswordResetTokenModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/contact/password_reset_request": {
      get: {
        tags: ["customer"],
        summary: "Customer Contact Password Reset Request Get",
        operationId: "customer_contact_password_reset_request_get",
        parameters: [{
          required: true,
          schema: {
            title: "Email",
            type: "string"
          },
          name: "email",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/contact/verify": {
      get: {
        tags: ["customer"],
        summary: "Customer Contact Verify Get",
        operationId: "customer_contact_verify_get",
        parameters: [{
          required: true,
          schema: {
            title: "Email",
            type: "string"
          },
          name: "email",
          "in": "query"
        }, {
          required: true,
          schema: {
            title: "Account Verification Code",
            type: "string"
          },
          name: "account_verification_code",
          "in": "query"
        }, {
          required: true,
          schema: {
            title: "App Name",
            type: "string"
          },
          name: "app_name",
          "in": "query"
        }],
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/LoginResultModel"
                }
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/customer/contact/request_verification": {
      post: {
        tags: ["customer"],
        summary: "Customer Contact Request Verification Post",
        operationId: "customer_contact_request_verification_post",
        parameters: [{
          required: true,
          schema: {
            title: "Email",
            type: "string"
          },
          name: "email",
          "in": "query"
        }],
        requestBody: {
          content: {
            "application/json": {
              schema: {
                $ref: "#/components/schemas/CustomerContactRequestVerificationModel"
              }
            }
          },
          required: true
        },
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          },
          "422": {
            description: "Validation Error",
            content: {
              "application/json": {
                schema: {
                  $ref: "#/components/schemas/HTTPValidationError"
                }
              }
            }
          }
        }
      }
    },
    "/healthz": {
      get: {
        summary: "Healthz Get",
        operationId: "healthz_get_healthz_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    }
  },
  components: {
    schemas: {
      AddressModel: {
        title: "AddressModel",
        type: "object",
        properties: {
          FIRSTNAME: {
            title: "Firstname",
            type: "string",
            "default": ""
          },
          LASTNAME: {
            title: "Lastname",
            type: "string",
            "default": ""
          },
          COMPANY: {
            title: "Company",
            type: "string",
            "default": ""
          },
          DEPARTMENT: {
            title: "Department",
            type: "string",
            "default": ""
          },
          ADDITION: {
            title: "Addition",
            type: "string",
            "default": ""
          },
          STREET: {
            title: "Street",
            type: "string",
            "default": ""
          },
          CITY: {
            title: "City",
            type: "string",
            "default": ""
          },
          ZIPCODE: {
            title: "Zipcode",
            type: "string",
            "default": ""
          },
          COUNTRY_CODE: {
            title: "Country Code",
            type: "string",
            "default": ""
          },
          POBOX_NUMBER: {
            title: "Pobox Number",
            type: "string",
            "default": ""
          },
          ADDRESS_TYPES: {
            type: "array",
            items: {
              $ref: "#/components/schemas/AddressTypeEnum"
            },
            "default": []
          },
          ID: {
            title: "Id",
            type: "string"
          }
        }
      },
      AddressTypeEnum: {
        title: "AddressTypeEnum",
        "enum": ["STANDARD", "DELIVERY", "INVOICE", "SENDER", "CREATOR", "QUOTE"],
        type: "string",
        description: "An enumeration."
      },
      CustomerContactExistsModel: {
        title: "CustomerContactExistsModel",
        required: ["EXISTS", "ACCOUNT_VERIFIED"],
        type: "object",
        properties: {
          EXISTS: {
            title: "Exists",
            type: "boolean"
          },
          ACCOUNT_VERIFIED: {
            title: "Account Verified",
            type: "boolean"
          }
        }
      },
      CustomerContactRequestVerificationModel: {
        title: "CustomerContactRequestVerificationModel",
        type: "object",
        properties: {
          PASSWORD: {
            title: "Password",
            type: "string"
          }
        }
      },
      CustomerPasswordResetTokenModel: {
        title: "CustomerPasswordResetTokenModel",
        required: ["TOKEN", "PASSWORD"],
        type: "object",
        properties: {
          TOKEN: {
            title: "Token",
            type: "string"
          },
          PASSWORD: {
            title: "Password",
            type: "string"
          }
        }
      },
      CustomerRegisterModel: {
        title: "CustomerRegisterModel",
        required: ["EMAIL", "FIRSTNAME", "LASTNAME", "PASSWORD"],
        type: "object",
        properties: {
          EMAIL: {
            title: "Email",
            type: "string"
          },
          FIRSTNAME: {
            title: "Firstname",
            type: "string"
          },
          LASTNAME: {
            title: "Lastname",
            type: "string"
          },
          PASSWORD: {
            title: "Password",
            type: "string"
          }
        }
      },
      HTTPValidationError: {
        title: "HTTPValidationError",
        type: "object",
        properties: {
          detail: {
            title: "Detail",
            type: "array",
            items: {
              $ref: "#/components/schemas/ValidationError"
            }
          }
        }
      },
      LoginCredentialsModel: {
        title: "LoginCredentialsModel",
        required: ["username", "password"],
        type: "object",
        properties: {
          username: {
            title: "Username",
            type: "string"
          },
          password: {
            title: "Password",
            type: "string"
          }
        }
      },
      LoginResultModel: {
        title: "LoginResultModel",
        required: ["session", "access_token"],
        type: "object",
        properties: {
          session: {
            $ref: "#/components/schemas/ShopSessionModel"
          },
          access_token: {
            title: "Access Token",
            type: "string"
          }
        }
      },
      ShopSessionDataCartModel: {
        title: "ShopSessionDataCartModel",
        type: "object",
        properties: {
          POSITIONS: {
            title: "Positions",
            type: "object",
            "default": {}
          },
          PAYMENT_METHOD: {
            title: "Payment Method",
            type: "string",
            "default": ""
          },
          PAYMENTS: {
            title: "Payments",
            type: "object",
            "default": {}
          },
          SHIPPING_PRICE: {
            title: "Shipping Price",
            type: "number"
          },
          SHIPPING_METHOD: {
            title: "Shipping Method",
            type: "string",
            "default": "STANDARD"
          },
          GOODS_VALUE: {
            title: "Goods Value",
            type: "number",
            "default": 0
          },
          TOTAL_PRICE: {
            title: "Total Price",
            type: "number",
            "default": 0
          },
          TOTAL_LOGISTIC_WEIGHT: {
            title: "Total Logistic Weight",
            type: "number",
            "default": 0
          },
          RECALCULATE_SHIPPING: {
            title: "Recalculate Shipping",
            type: "boolean",
            "default": false
          },
          RECALCULATE_WEIGHT: {
            title: "Recalculate Weight",
            type: "boolean",
            "default": false
          },
          POINTS_GAIN: {
            title: "Points Gain",
            type: "integer",
            "default": 0
          },
          SURCHARGE_DISCOUNT_COST: {
            title: "Surcharge Discount Cost",
            type: "object",
            "default": {}
          },
          ORDER_NUMBER: {
            title: "Order Number",
            type: "string"
          },
          TAX_TYPES: {
            title: "Tax Types",
            type: "object"
          }
        }
      },
      ShopSessionDataCustomerModel: {
        title: "ShopSessionDataCustomerModel",
        type: "object",
        properties: {
          GUEST: {
            title: "Guest",
            type: "boolean",
            "default": true
          },
          CUSTOMER_ID: {
            title: "Customer Id",
            type: "integer"
          },
          EMAIL: {
            title: "Email",
            type: "string"
          },
          LANGUAGE_CODE: {
            title: "Language Code",
            type: "string"
          },
          NEWSLETTER: {
            title: "Newsletter",
            type: "string"
          },
          CUSTOMER_TYPE: {
            title: "Customer Type",
            type: "string",
            "default": "PRIVATE"
          },
          CONTACT_ID: {
            title: "Contact Id",
            type: "string"
          },
          ACCOUNT_VERIFIED: {
            title: "Account Verified",
            type: "boolean",
            "default": false
          }
        }
      },
      ShopSessionDataModel: {
        title: "ShopSessionDataModel",
        type: "object",
        properties: {
          VERSION: {
            title: "Version",
            type: "integer",
            "default": 1
          },
          CUSTOMER: {
            $ref: "#/components/schemas/ShopSessionDataCustomerModel"
          },
          CART: {
            $ref: "#/components/schemas/ShopSessionDataCartModel"
          },
          ADDRESSES: {
            title: "Addresses",
            type: "object",
            additionalProperties: {
              $ref: "#/components/schemas/AddressModel"
            },
            "default": {}
          },
          CUSTOMER_CARD: {
            title: "Customer Card",
            type: "string"
          }
        }
      },
      ShopSessionModel: {
        title: "ShopSessionModel",
        required: ["SESSION_ID", "APP_NAME", "CLIENT_IDS", "DATA"],
        type: "object",
        properties: {
          SESSION_ID: {
            title: "Session Id",
            type: "string"
          },
          APP_NAME: {
            title: "App Name",
            type: "string"
          },
          CLIENT_IDS: {
            title: "Client Ids",
            type: "array",
            items: {
              type: "string"
            }
          },
          ACCOUNT_ID: {
            title: "Account Id",
            type: "string"
          },
          DATA: {
            $ref: "#/components/schemas/ShopSessionDataModel"
          },
          EXPIRES: {
            title: "Expires",
            type: "string",
            format: "date-time"
          },
          INITIALIZED: {
            title: "Initialized",
            type: "boolean",
            "default": false
          },
          FIRST_ASSIGN: {
            title: "First Assign",
            type: "boolean",
            "default": true
          },
          UPDATED: {
            title: "Updated",
            type: "string",
            format: "date-time"
          },
          CREATED: {
            title: "Created",
            type: "string",
            format: "date-time"
          }
        }
      },
      ValidationError: {
        title: "ValidationError",
        required: ["loc", "msg", "type"],
        type: "object",
        properties: {
          loc: {
            title: "Location",
            type: "array",
            items: {
              type: "string"
            }
          },
          msg: {
            title: "Message",
            type: "string"
          },
          type: {
            title: "Error Type",
            type: "string"
          }
        }
      }
    }
  }
};
var shop_api = (0, _lsfastapiClient.Api)(openapi);
exports.shop_api = shop_api;
//# sourceMappingURL=index.js.map